<template>
    <b-tabs
        class="apprentice-tab module-period-overview-tabs"
        content-class="module-period-overview-content">
        <b-tab
            :title="$t('modules.overview_by_module')"
            active>
            <design-2021-module-period-overview-modules-component
                :period-in="periodIn"
                :module-period-in="modulePeriodIn">
            </design-2021-module-period-overview-modules-component>
        </b-tab>
        <b-tab :title="$t('modules.overview_by_student')">
            <design-2021-module-period-overview-students-component
                :period-in="periodIn"
                :module-period-in="modulePeriodIn"
                :unsubscribed-students-in="unsubscribedStudentsIn">
            </design-2021-module-period-overview-students-component>
        </b-tab>
    </b-tabs>
</template>

<script>
import Design2021ApprenticeDataTable from '../common/design-2021-apprentice-data-table.vue';

export default {
    name: 'design-2021-module-period-overview-component',
    props: {
        periodIn: {
            type: Object,
            required: true,
            default: () => {},
        },
        modulePeriodIn: {
            type: Array,
            required: true,
            default: () => {},
        },
        unsubscribedStudentsIn: {
            type: Array,
            required: true,
            default: [],
        },
    },
    components: { Design2021ApprenticeDataTable },
    data() {
        return {
            modal: false,
            period: null,
            moduleDates: null,
            fields: [
                {
                    key: 'modules',
                    label: 'Module',
                },
                {
                    key: 'users',
                    label: this.$t('modules.participants'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        show(periodId) {
            this.modal = true;
            this.alert.loading();
            this.axios.get(this.routes.getManagementModulesByPeriod(periodId)).then(
                (response) => {
                    this.alert.loaded();
                    this.period = response.data.period;
                    this.period.duration = response.data.duration;
                    this.period.weekday = response.data.weekday;
                    this.moduleDates = response.data.modules_dates;
                },

                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },

    computed: {
        // modules() {
        //     if(this.moduleDates.length === 0){
        //         return [];
        //     }
        //
        //     let availableModules = this.moduleDates.map(module_date => {
        //         let module = {
        //             id: module_date.module_id,
        //             max_students: module_date.max,
        //             module_period_id: module_date.module_period_id,
        //             location: module_date.module.location,
        //             title: module_date.module.title,
        //             module_users: module_date.module.module_users,
        //         }
        //         return module;
        //     });
        //
        //     return availableModules;
        // }
    },
};
</script>

<style scoped lang="scss"></style>
